import Vue from "vue";


export const initHandlers = () => {
  Vue.config.silent = false;
  Vue.config.errorHandler = function(err, vm, info) {
    let component='Unknown';
    if (vm.$el && typeof(vm.$el)!=='undefined' && vm.$el.baseURI ){
      component=vm.$el.baseURI;
    }
      let errorMessage = `Unexpected error: ${err} - Component: ${component} - Detail: ${info}`;
      if(vm.$logger && typeof(vm.$logger)!=='undefined'){
          vm.$logger.error(errorMessage, vm.$vnode.tag);
        }
  };
  
  Vue.config.warnHandler = function(msg, vm, info) {
    let component='Unknown';
    if (vm && vm.$el && typeof(vm.$el)!=='undefined' ){
        component=vm.$el.id;
      }
      let errorMessage = `warning: ${msg} - Component: ${vm} - Detail: ${info}`;
      if(vm && vm.$logger && typeof(vm.$logger)!=='undefined'){
          vm.$logger.console.warn(errorMessage, vm.$vnode.tag);
        } else {
          console.warn(msg)
        }
  };
}

